import { type FC } from "react";

import { useQuery } from "@apollo/client/react";

import { ProjectDraftingTemplateDocument } from "@app_schema";

import { NoticeLine } from "@styled/notice_line";
import { ReportPagesColumn } from "@styled/report_pages_bar";
import {
  TemplateOutlineItem,
  TemplateOutlinePage,
} from "@styled/template_outline";

// The Template view: his template's sections, read-only, under the pages of
// this case's draft they're on. Sections are added and edited in the Report.
export const DraftTemplateView: FC<{ projectId: string; hidden: boolean }> = ({
  projectId,
  hidden,
}) => {
  const { data } = useQuery(ProjectDraftingTemplateDocument, {
    variables: { id: projectId },
    skip: hidden,
    fetchPolicy: "cache-and-network",
  });
  const view = data?.project.draftTemplateView;

  return (
    <ReportPagesColumn background="white" hidden={hidden}>
      {view && (
        <NoticeLine>
          {view.line}. Read-only here: add and edit sections in Report.
        </NoticeLine>
      )}
      {view?.pages.map((page) => (
        <TemplateOutlinePage
          key={page.sections[0]?.id}
          label={page.number ? `Page ${String(page.number)}` : undefined}
        >
          {page.sections.map((section) => (
            <TemplateOutlineItem
              key={section.id}
              name={section.name}
              line={`${section.sourcesLabel} · ${section.after}`}
            />
          ))}
        </TemplateOutlinePage>
      ))}
    </ReportPagesColumn>
  );
};
